var RangeSelector = class extends HTMLElement {
  #abortController;
  connectedCallback() {
    this.#abortController = new AbortController();
    const rangeLowerBound = this.querySelector(
        'input[type="range"]:first-child'
      ),
      rangeHigherBound = this.querySelector('input[type="range"]:last-child'),
      textInputLowerBound = this.querySelector(".filter-range-min"),
      textInputHigherBound = this.querySelector(".filter-range-max"),
      rangeGroup = this.querySelector(".range-group");
    this.rangeValues = Array.from(
      textInputLowerBound.querySelectorAll("option")
    ).map((option) => parseFloat(option.value));

    //console.log(this.rangeValues);
    //textInputLowerBound.addEventListener('focus', () => textInputLowerBound.select(), { signal: this.#abortController.signal });
    //textInputHigherBound.addEventListener('focus', () => textInputHigherBound.select(), { signal: this.#abortController.signal });

    // Store the range elements for reference
    this.rangeElements = [rangeLowerBound, rangeHigherBound];

    // Set up improved touch handling for range inputs
    const setupRangeTouch = (rangeInput) => {
      // Prevent default behavior on touchstart to avoid potential browser handling conflicts
      rangeInput.addEventListener(
        "touchstart",
        (e) => {
          // Don't prevent default here as it would prevent the range from receiving focus
          rangeInput.focus();
        },
        { signal: this.#abortController.signal }
      );

      // Handle touch move on the range input directly
      rangeInput.addEventListener(
        "touchmove",
        (e) => {
          // Do not prevent default here to allow the range to move
          // Calculate touch position relative to the range input
          const touch = e.touches[0];
          const rangeRect = rangeInput.getBoundingClientRect();
          const percent = Math.max(
            0,
            Math.min(1, (touch.clientX - rangeRect.left) / rangeRect.width)
          );

          // Set the range value based on the touch position
          const min = parseFloat(rangeInput.min);
          const max = parseFloat(rangeInput.max);
          const newValue = min + percent * (max - min);
          rangeInput.value = newValue;

          // Trigger the input event to update the range styling and values
          rangeInput.dispatchEvent(new Event("input", { bubbles: true }));

          // Prevent page scrolling while adjusting the range
          e.preventDefault();
        },
        { passive: false, signal: this.#abortController.signal }
      );
    };

    // Apply touch handling to both range inputs
    setupRangeTouch(rangeLowerBound);
    setupRangeTouch(rangeHigherBound);

    // Prevent page scrolling when interacting with the range-selector
    this.addEventListener(
      "touchmove",
      (e) => {
        // Only prevent default if the touch is on our component but not on range inputs
        const isOnRange = e.target.matches('input[type="range"]');
        if (!isOnRange) {
          e.preventDefault();
        }
      },
      { passive: false, signal: this.#abortController.signal }
    );

    textInputLowerBound.addEventListener(
      "change",
      (event) => {
        event.preventDefault();
        const max = parseFloat(event.target.dataset.max || event.target.max);
        const min = parseFloat(event.target.dataset.min || event.target.min);
        //event.target.value = Math.max(Math.min(parseFloat(event.target.value), parseFloat(textInputHigherBound.value || max) - 1), min);
        //console.log('textInputLowerBound', event.target.value);
        rangeLowerBound.value = event.target.value;
        rangeLowerBound.parentElement.style.setProperty(
          "--range-min",
          `${
            (parseFloat(rangeLowerBound.value) /
              parseFloat(rangeLowerBound.max)) *
            100
          }%`
        );
      },
      { signal: this.#abortController.signal }
    );
    textInputHigherBound.addEventListener(
      "change",
      (event) => {
        event.preventDefault();
        const max = parseFloat(event.target.dataset.max || event.target.max);
        const min = parseFloat(event.target.dataset.min || event.target.min);
        //event.target.value = Math.min(Math.max(parseFloat(event.target.value), parseFloat(textInputLowerBound.value || min) + 1), max);
        //console.log('textInputHigherBound', event.target.value);
        rangeHigherBound.value = event.target.value;
        rangeHigherBound.parentElement.style.setProperty(
          "--range-max",
          `${
            (parseFloat(rangeHigherBound.value) /
              parseFloat(rangeHigherBound.max)) *
            100
          }%`
        );
      },
      { signal: this.#abortController.signal }
    );
    rangeLowerBound.addEventListener(
      "change",
      (event) => {
        event.stopPropagation();
        const newValue = this.closestNumber(
          parseFloat(event.target.value),
          this.rangeValues
        );
        textInputLowerBound.value = newValue;
        textInputLowerBound.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      },
      { signal: this.#abortController.signal }
    );
    rangeHigherBound.addEventListener(
      "change",
      (event) => {
        event.stopPropagation();
        console.log(
          "parseFloat(event.target.value)",
          parseFloat(event.target.value)
        );

        const newValue = this.closestNumber(
          parseFloat(event.target.value),
          this.rangeValues
        );
        textInputHigherBound.value = newValue;
        textInputHigherBound.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      },
      { signal: this.#abortController.signal }
    );
    rangeLowerBound.addEventListener(
      "input",
      (event) => {
        event.target.value = Math.min(
          parseFloat(event.target.value),
          parseFloat(textInputHigherBound.value || event.target.max) - 1
        );
        event.target.parentElement.style.setProperty(
          "--range-min",
          `${
            (parseFloat(event.target.value) / parseFloat(event.target.max)) *
            100
          }%`
        );
        const newValue = this.closestNumber(
          parseFloat(event.target.value),
          this.rangeValues
        );
        textInputLowerBound.value = newValue;
      },
      { signal: this.#abortController.signal }
    );
    rangeHigherBound.addEventListener(
      "input",
      (event) => {
        event.target.value = Math.max(
          parseFloat(event.target.value),
          parseFloat(textInputLowerBound.value || event.target.min) + 1
        );
        event.target.parentElement.style.setProperty(
          "--range-max",
          `${
            (parseFloat(event.target.value) / parseFloat(event.target.max)) *
            100
          }%`
        );
        const newValue = this.closestNumber(
          parseFloat(event.target.value),
          this.rangeValues
        );
        textInputHigherBound.value = newValue;
      },
      { signal: this.#abortController.signal }
    );
    //textInputLowerBound.dispatchEvent(new Event('change', { bubbles: true }));
    //textInputHigherBound.dispatchEvent(new Event('change', { bubbles: true }));

    // Add click handler for the range group
    rangeGroup.addEventListener(
      "click",
      (e) => {
        const rect = rangeGroup.getBoundingClientRect();
        const percent = (e.clientX - rect.left) / rect.width;
        const min = parseFloat(rangeLowerBound.min);
        const max = parseFloat(rangeHigherBound.max);
        const newValue = min + percent * (max - min);

        // Determine which input to update based on which is closer to the clicked position
        const minValue = parseFloat(rangeLowerBound.value);
        const maxValue = parseFloat(rangeHigherBound.value);
        const minDiff = Math.abs(newValue - minValue);
        const maxDiff = Math.abs(newValue - maxValue);

        if (minDiff < maxDiff) {
          rangeLowerBound.value = newValue;
          rangeLowerBound.dispatchEvent(new Event("input", { bubbles: true }));
        } else {
          rangeHigherBound.value = newValue;
          rangeHigherBound.dispatchEvent(new Event("input", { bubbles: true }));
        }
      },
      { signal: this.#abortController.signal }
    );
  }
  closestNumber(num, arr) {
    const number = arr.reduce((prev, curr) => {
      return Math.abs(curr - num) < Math.abs(prev - num) ? curr : prev;
    });
    return number.toFixed(2).toString();
  }
  disconnectedCallback() {
    // The abortController will clean up all event listeners that were attached with its signal
    this.#abortController.abort();
  }
};
if (!window.customElements.get("range-selector")) {
  window.customElements.define("range-selector", RangeSelector);
}
